var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('div', {
        staticClass: "page"
    }, [
        _c('img', {
            attrs: {
                "src": _setup.currObj.img,
                "alt": ""
            }
        }),
        _c('h3', [
            _vm._v(_vm._s(_setup.currObj.title))
        ]),
        _vm._l(_setup.currObj.content, function(item, index) {
            return _c('p', {
                key: index
            }, [
                _vm._v(_vm._s(item))
            ]);
        }),
        _setup.currObj.btn ? _c('div', {
            staticClass: "submit",
            on: {
                "click": _setup.pushPage
            }
        }, [
            _vm._v(_vm._s(_setup.currObj.btn))
        ]) : _vm._e()
    ], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };
